import React from "react";
import { cleanJoin } from "../../../utils/stringUtil";

function NavigationStart({ children, isHidden }) {
  return <div className={cleanJoin("navbar-start", isHidden ? " is-hidden" : "")}>{children}</div>;
}

export default NavigationStart;
